export default "__VITE_ASSET__fe870a42__"